import Button from "../../../components/ui/Button";
import PropTypes from "prop-types";

const HighVolumeCard = ({
    messages = [],
    handleHighVolumeExport,
    dataViewType,
}) => {
    return (
        <div
            className="section-card d-flex align-items-center justify-content-center"
            style={{ height: 432 }}
        >
            <div className="text-center">
                {messages.map(
                    (
                        { header, subheader, color, icon, button, renderNote },
                        index
                    ) => (
                        <div
                            key={header || index}
                            className="d-flex flex-column align-items-center"
                        >
                            {icon && (
                                <img
                                    className="mb-24p"
                                    src={icon}
                                    alt="High Volume Icon"
                                    loading="lazy"
                                    style={{ width: 120, height: 120 }}
                                />
                            )}

                            {header && (
                                <h3
                                    className="section-card-title"
                                    style={{ color }}
                                >
                                    {header}
                                </h3>
                            )}

                            {renderNote &&
                                typeof renderNote === "function" &&
                                renderNote(dataViewType)}

                            {subheader && (
                                <p className="section-card-subtitle">
                                    {subheader}
                                </p>
                            )}

                            {button && (
                                <Button
                                    size="sm"
                                    onClick={handleHighVolumeExport}
                                    text={button}
                                    icon="fa-download"
                                    pageType="reportSaving"
                                    iconAfterText
                                    style={{
                                        fontSize: "20px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "8px 16px",
                                        width: "auto",
                                    }}
                                />
                            )}
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

HighVolumeCard.propTypes = {
    messages: PropTypes.arrayOf(
        PropTypes.shape({
            header: PropTypes.node,
            subheader: PropTypes.node,
            color: PropTypes.string,
            icon: PropTypes.string,
            button: PropTypes.string,
        })
    ),
    handleHighVolumeExport: PropTypes.func,
};

export default HighVolumeCard;
